var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.pageComponent,{tag:"Component",attrs:{"page-data":_vm.pageData}},[_c(_vm.slotComponent,{tag:"Component",attrs:{"page-data":_vm.pageData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }